import React from 'react';
import {Container, Grid, Link, Text, Tooltip} from "@nextui-org/react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faGithub, faLinkedinIn} from '@fortawesome/fontawesome-free-brands'
import {faEnvelope} from '@fortawesome/fontawesome-free-regular'
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import '../styles/about.css';

function About() {
    return (
        <Grid.Container gap={3} justify={'center'}>
            <Grid lg={2}>
                <Container>
                    <Text h1>Hi There!</Text>
                    <Grid.Container gap={1} justify={'center'}>
                        <Grid>
                            <Tooltip content={'LinkedIn'}>
                                <Link href={'https://www.linkedin.com/in/chirag-gupta-7853b5132'} target={'_blank'}>
                                    <FontAwesomeIcon icon={faLinkedinIn as IconProp}/>
                                </Link>
                            </Tooltip>
                        </Grid>
                        <Grid>
                            <Tooltip content={'Github'}>
                                <Link href={'https://github.com/chirag-ji'} target={'_blank'}>
                                    <FontAwesomeIcon icon={faGithub as IconProp}/>
                                </Link>
                            </Tooltip>
                        </Grid>
                        <Grid>
                            <Tooltip content={'Mail'}>
                                <Link href={'mailto:chiragji.com@outlook.in'}>
                                    <FontAwesomeIcon icon={faEnvelope as IconProp}/>
                                </Link>
                            </Tooltip>
                        </Grid>
                    </Grid.Container>
                </Container>
            </Grid>
            <Grid xs={7}>
                <Container>
                    <p>
                        I'm Chirag Gupta, an Enthusiastic and Professional Software Developer motivated to the
                        development and optimization of software.
                    </p>
                    <p>
                        I'm a Java Software Engineer at Publicis Sapient, since March 2021.
                        At Publicis Sapient, I primarily work in the custody domain, and my task is to develop highly
                        reactive and scalable applications with optimized and high efficient code.
                    </p>
                    <p>
                        Moreover, I love to develop new and challenging applications in my time with friendly &
                        responsive UI.
                    </p>
                </Container>
            </Grid>
        </Grid.Container>
    );
}

export default About;
